export default __webpack_public_path__ + "static/media/area3_960.aff217b4.webp";